// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__V3nS7","inputBox":"SearchBar_inputBox__cBelI"};